/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_X15_Invite_OnlyInputs */

const en_auth_x15_invite_only = /** @type {(inputs: Auth_X15_Invite_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accounts are made by invitation from your admin.`)
};

/** @type {(inputs: Auth_X15_Invite_OnlyInputs) => LocalizedString} */
const ar_auth_x15_invite_only = en_auth_x15_invite_only;

/** @type {(inputs: Auth_X15_Invite_OnlyInputs) => LocalizedString} */
const he_auth_x15_invite_only = en_auth_x15_invite_only;

/** @type {(inputs: Auth_X15_Invite_OnlyInputs) => LocalizedString} */
const ur_auth_x15_invite_only = en_auth_x15_invite_only;

/** @type {(inputs: Auth_X15_Invite_OnlyInputs) => LocalizedString} */
const es_auth_x15_invite_only = en_auth_x15_invite_only;

/** @type {(inputs: Auth_X15_Invite_OnlyInputs) => LocalizedString} */
const fr_auth_x15_invite_only = en_auth_x15_invite_only;

/** @type {(inputs: Auth_X15_Invite_OnlyInputs) => LocalizedString} */
const de_auth_x15_invite_only = en_auth_x15_invite_only;

/** @type {(inputs: Auth_X15_Invite_OnlyInputs) => LocalizedString} */
const pt_auth_x15_invite_only = en_auth_x15_invite_only;

/** @type {(inputs: Auth_X15_Invite_OnlyInputs) => LocalizedString} */
const hi_auth_x15_invite_only = en_auth_x15_invite_only;

/** @type {(inputs: Auth_X15_Invite_OnlyInputs) => LocalizedString} */
const bn_auth_x15_invite_only = en_auth_x15_invite_only;

/**
* | output |
* | --- |
* | "Accounts are made by invitation from your admin." |
*
* @param {Auth_X15_Invite_OnlyInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const auth_x15_invite_only = /** @type {((inputs?: Auth_X15_Invite_OnlyInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_X15_Invite_OnlyInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_auth_x15_invite_only(inputs)
	if (locale === "he") return he_auth_x15_invite_only(inputs)
	if (locale === "ur") return ur_auth_x15_invite_only(inputs)
	if (locale === "es") return es_auth_x15_invite_only(inputs)
	if (locale === "fr") return fr_auth_x15_invite_only(inputs)
	if (locale === "de") return de_auth_x15_invite_only(inputs)
	if (locale === "pt") return pt_auth_x15_invite_only(inputs)
	if (locale === "hi") return hi_auth_x15_invite_only(inputs)
	if (locale === "bn") return bn_auth_x15_invite_only(inputs)
	return /** @type {LocalizedString} */ ("Accounts are made by invitation from your admin.")
});